import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  size: 'full',
  path: 'contacts',
  children: {
    contactId: {
      size: 'full',
      path: ':contactId',
      children: {
        edit: {
          size: 'full',
          path: 'edit',
        },
        overview: {
          size: 'full',
          path: 'overview',
        },
        projects: {
          size: 'full',
          path: 'projects',
        },
        purchaseOrders: {
          size: 'full',
          path: 'purchase-orders',
        },
        invoices: {
          size: 'full',
          path: 'invoices',
        },
      },
    },
  },
} as const satisfies Location
